import React, { FC, useContext } from 'react'

import { ForeignPhotoContext } from 'components/page/ForeignProfile/ForeignProfile.constants'
import { skipEndPointIncognito } from 'components/page/ForeignProfile/Photos/function/skipEndPointIncogito'
import {
  Image,
  Mask,
  WrapperLast,
} from 'components/page/ForeignProfile/Photos/Photos.styled'
import { GQLPhotoFaceCenter } from 'generated-graphql/graphql'

export const PhotosTileLastBlockView: FC<{
  photoId: number
  photoUrl: string
  count: number
  width?: number
  height?: number
  coordinates?: GQLPhotoFaceCenter | null
}> = ({ photoId, photoUrl, count, width, height, coordinates }) => {
  const { baseHrefPhoto, useAuthorizationUrl } = useContext(ForeignPhotoContext)
  const url = skipEndPointIncognito(baseHrefPhoto, photoId, useAuthorizationUrl)

  /**
   * https://redmine.mamba.ru/issues/120267
   * Если фото 1, то мы не показываем маску
   * Если фото больше 1, то мы показываем. При этом в число на маске равно всем оставшимся фото,
   * включая ту, которая под маской.
   */
  return (
    <WrapperLast to={url} data-name="photos-more-action">
      <Image
        src={photoUrl}
        width={width}
        height={height}
        $coordinates={coordinates}
        data-name={`photos-${photoId}-photo`}
      />
      {count > 1 && <Mask>+ {count}</Mask>}
    </WrapperLast>
  )
}
